import { render, staticRenderFns } from "./QuestionVotingDetailView.vue?vue&type=template&id=c771ba6e&scoped=true"
import script from "./QuestionVotingDetailView.vue?vue&type=script&lang=ts"
export * from "./QuestionVotingDetailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c771ba6e",
  null
  
)

export default component.exports